/** @format */

import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideService } from "../../../store/stateSlice";
import Popup from "../../global/form create/Popup";
import UploadPhoto from "../../inputs/UploadPhoto";
import InputSelect from "../../inputs/InputSelect";
import InputField from "../../inputs/inputField";
import InputTextarea from "../../inputs/inputTextarea";
import { Checkbox } from "antd";

const NewServices = () => {
  //view pupup when onclick "اضافة مجموعة خدمات جديدة"
  const viewPupup = useSelector((state) => state.toggleState.value.newService);
  const dispatch = useDispatch();
  const hidePupup = () => {
    dispatch(hideService());
  };
  // handel data form
  const [state, setState] = useState("");

  const [values, setValues] = useState({
    photo: "",
    viewPhoto: "",
    users: [],
    en_name: "",
    ar_name: "",
  });

  // State to store uploaded file
  const [file, setFile] = React.useState("");

  // Handles file upload event and updates state
  function handleUpload(event) {
    setFile(event.target.files[0]);
  }

  return (
    <Popup viewPupup={viewPupup} hidePupup={hidePupup} viewWidth="content-xl">
      <form className="main-contnt">
        <div className="head-content">
          <UploadPhoto
            name="NewServices"
            handleUpload={handleUpload}
            file={file}
            image={values.photo}
            value={values.photo}
          />
        </div>
        <div className="body-content">
          <InputSelect
            value={state}
            name="cat_status"
            label="حالة الخدمة"
            onChange={setState}
            options={[
              { label: "نشطة", value: "active" },
              { label: "غير نشطة ", value: "inactive" },
            ]}
            placeholder="اختر حالة المجموعة"
            note="*"
          />
          <InputField
            title="  اسم الخدمة باللغة العربية"
            placeholder="اكتب اسم الخدمة"
            note="*"
          />
          <InputField
            title="  اسم الخدمة باللغة الانجليزية"
            placeholder="اكتب اسم الخدمة"
            note="*"
          />
          <InputField
            title="سعر الخدمة"
            placeholder="اكتب سعر الخدمة"
            note="*"
          />
          <InputTextarea
            title="وصف الخدمة باللغة العربية"
            placeholder="اكتب شروط و احكام الخدمة"
          />
          <InputTextarea
            title="وصف الخدمة باللغة الانجليزية "
            placeholder="اكتب شروط و احكام الخدمة"
          />
          <InputTextarea
            title=" الشروط والاحكام باللغة العربية "
            placeholder="اكتب شروط و احكام الخدمة"
          />
          <InputTextarea
            title=" الشروط والاحكام باللغة الانجليزية "
            placeholder="اكتب شروط و احكام الخدمة"
          />
        </div>
        <div className="buttons-contnt display-flex center-flex ">
          <div class="btn btn__primary">اضافه</div>
          <div class="btn btn__danger" onClick={hidePupup}>
            الغاء
          </div>
        </div>
      </form>
    </Popup>
  );
};

export default NewServices;
